<app-politica-de-privacidade-modal #appPoliticaDePrivacidadeModal></app-politica-de-privacidade-modal>

<div id="layout-footer" class="layout-footer clearfix container">
  <a href="#">
    <img 
      alt="logo" 
      src='{{ arquivoLogoPequenaColorida }}' 
      class="logo" 
      [ngClass]="isGEEO ? 'logo-geeo' : 'logo-healthmap'"/>
  </a>

  <span class="footer-text-right">
    <!-- <label class="tag tag-cinza tag-fundo-branco email-do-suporte no-print" *ngIf="isGEEO">
      <span class="material-icons-outlined icone-suporte no-print">campaign</span>
      suporte@geeo.com.br
    </label> -->
    <!-- <span class="material-icons">copyright</span> -->
    <!-- <span>{{nomeVersao}}</span> -->
    <span class="versao-texto">{{ambiente?.nome}} . <label class="tag-chip">{{ tenant?.nome }}</label> . ui {{nomeVersao}} . api {{ambiente?.versaoAPI}}</span>
    <span class='politica-link no-print tag-chip' (click)="exibirPolitica()">
      <a href='javascript:void(0);'>Política de privacidade</a>
    </span>
  </span>
</div>